import { Button } from '@ordr-as/umami-react/button';
import { Item, Select } from '@ordr-as/umami-react/form';
import React from 'react';
import { usePlacements, usePlacementsActions, useSelectedPlacementId } from '../../context/PlacementsStore';

interface ReceiptFormProps {
  handlePrint: (placementId: number) => void;
  isDisabled?: boolean;
  buttonLabel: string;
  beta?: boolean;
}

const PrintForm = (props: ReceiptFormProps) => {
  const { handlePrint, isDisabled, buttonLabel, beta } = props;
  const placements = usePlacements();
  const selectedPlacementId = useSelectedPlacementId();
  const { setSelectedPlacementId } = usePlacementsActions();

  const handleChangePlacement = (key: React.Key) => {
    const id = Number.parseInt(key.toString());
    if (!Number.isNaN(id)) {
      setSelectedPlacementId(id);
    }
  };

  const print = () => {
    if (selectedPlacementId) {
      handlePrint(selectedPlacementId);
    }
  };

  return placements.length > 0 ? (
    <div className="desktop:grid desktop:grid-cols-5 items-end gap-4">
      <Select
        className="col-span-3"
        buttonClassName="max-h-7 truncate"
        label="printer"
        onSelectionChange={(key) => key && handleChangePlacement(key)}
        selectedKey={selectedPlacementId?.toString()}
        fullWidth
      >
        {placements.map((placement) => (
          <Item key={placement.id} textValue={placement.name}>
            {placement.name}
          </Item>
        ))}
      </Select>
      <div className="desktop:col-span-2 mt-4">
        <Button className="btn-secondary w-full" kind="secondary" onClick={print} isDisabled={isDisabled} fullWidth>
          <p className="whitespace-nowrap">
            {buttonLabel}
            {beta && ' (BETA)'}
          </p>
        </Button>
      </div>
    </div>
  ) : null;
};

export default PrintForm;
